<mat-dialog-content>
  <h2 mat-dialog-title>{{ title }}</h2>
  <ng-container
    *ngIf="(loadingDeclinedReasons$$ | async) === false; else loadingTemplate"
  >
    <ng-container
      *ngIf="
        (declinedReasonsApiError$$ | async) === false;
        else declineReasonsError
      "
    >
      <p>{{ details }}</p>
      <form
        [formGroup]="form"
        *ngIf="declinedReasons$$ | async as declinedReasons"
      >
        <ng-container>
          <glxy-form-field size="large" *ngIf="declinedReasons.length > 0">
            <glxy-label>
              {{ 'FRONTEND.SALES_UI.DECLINE_REASON.REASONS_TITLE' | translate }}
              <span class="label-required">
                {{ 'FRONTEND.SALES_UI.DECLINE_REASON.REQUIRED' | translate }}
              </span>
            </glxy-label>
            <mat-error *ngIf="formReasonId.dirty && formReasonId.invalid">
              {{ 'FRONTEND.SALES_UI.DECLINE_REASON_VALIDATION' | translate }}
            </mat-error>
            <mat-radio-group [formControl]="formReasonId">
              <mat-radio-button
                *ngFor="let declineReason of declinedReasons"
                [value]="declineReason.id"
              >
                {{ declineReason.reason }}
              </mat-radio-button>
            </mat-radio-group>
          </glxy-form-field>
        </ng-container>
        <glxy-form-field>
          <glxy-label>
            {{ 'FRONTEND.SALES_UI.DECLINE_REASON.MESSAGE' | translate }}
          </glxy-label>
          <textarea
            matInput
            [formControl]="formMessage"
            placeholder="{{ 'FRONTEND.SALES_UI.MESSAGE' | translate }}"
            [required]="declinedReasons.length === 0 || null"
          ></textarea>
          <mat-error *ngIf="formMessage.dirty && formMessage.invalid">
            {{ 'FRONTEND.SALES_UI.DECLINE_MESSAGE_VALIDATION' | translate }}
          </mat-error>
        </glxy-form-field>
      </form>
    </ng-container>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="dialog-secondary-actions">
    <a routerLink="/customize-design/sales-orders-decline-reasons">
      {{ 'FRONTEND.SALES_UI.DECLINE_REASON.MANAGE_REASONS' | translate }}
    </a>
  </div>
  <button mat-stroked-button color="secondary" mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.CANCEL' | translate }}
  </button>
  <ng-container *ngIf="leaseOrderToAutomations$ | async; else declineButton">
    <button
      mat-flat-button
      color="primary"
      [disabled]="(submitDisabled$ | async) || form.invalid"
      (click)="onLeaseBtnPressed()"
    >
      {{ 'FRONTEND.SALES_UI.DECLINE' | translate }}
    </button>
  </ng-container>
  <ng-template #declineButton>
    <button
      mat-flat-button
      color="primary"
      [disabled]="(submitDisabled$ | async) || form.invalid"
      (click)="onDecline()"
    >
      {{ 'FRONTEND.SALES_UI.DECLINE' | translate }}
    </button>
  </ng-template>
</mat-dialog-actions>
<ng-template #loadingTemplate>
  <div class="loading-container">
    <mat-spinner diameter="36"></mat-spinner>
  </div>
</ng-template>
<ng-template #declineReasonsError>
  <div class="content-container">
    <div class="declined-reasons-error-text">
      {{ 'FRONTEND.SALES_UI.DECLINE_REASON.ERROR' | translate }}
    </div>
    <div class="declined-reasons-error-button">
      <button mat-stroked-button (click)="loadDeclinedReasons()">
        {{ 'FRONTEND.SALES_UI.DECLINE_REASON.TRY_AGAIN' | translate }}
      </button>
    </div>
  </div>
</ng-template>
